import { AlcoholModalFactory } from "src/storefront/types/restriction_modal_factories/alcohol_modal_factory";
import { RestrictionType } from "../storefront";


export interface RestrictionModalFactory {
    type: RestrictionType;
    modal: (onConfirm: () => void, onClose: () => void) => React.JSX.Element;
}

export const getRestrictionModalFactory = (restrictionType: RestrictionType): RestrictionModalFactory => {
    switch (restrictionType) {
        case RestrictionType.age_r18:
            return new AlcoholModalFactory();
    }
}
